<template>
  <div>
    <DemandMaterialTable :orderCode="orderCode" :disabled="disabled" />
  </div>
</template>

<script>
import DemandMaterialTable from './components/demand-material-table'
export default {
  components: {
    DemandMaterialTable,
  },
  props: {
    orderCode: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
